import { useRestApiProvider } from "@jugl-web/rest-api";
import { TaskCustomStatusDto } from "@jugl-web/rest-api/tasks/models/TaskCustomStatus";
import { FC, ReactNode, useEffect } from "react";
import { useTaskBoardsQuery } from "../../hooks/useTaskBoardsQuery";
import { useTaskStatuses } from "../../hooks/useTaskStatuses";

interface HeadlessTaskStatusProps {
  entityId: string;
  boardId: string | null;
  statusId: string;
  supportForeignBoardStatus?: boolean;
  children: (props: {
    status: TaskCustomStatusDto | undefined;
    safeStatus: TaskCustomStatusDto;
    isLoading: boolean;
  }) => ReactNode;
}

export const HeadlessTaskStatus: FC<HeadlessTaskStatusProps> = ({
  entityId,
  boardId,
  statusId,
  supportForeignBoardStatus,
  children,
}) => {
  const { getStatusById, getStatusByIdWithFallback } = useTaskStatuses({
    entityId,
    boardId,
  });

  const { isLoading: areBoardsLoading } = useTaskBoardsQuery({ entityId });

  const { tasksApi } = useRestApiProvider();

  const [getPreviewTaskBoard, { isLoading: isPreviewBoardLoading }] =
    tasksApi.useLazyGetPreviewTaskBoardQuery();

  const isLoading = boardId ? isPreviewBoardLoading || areBoardsLoading : false;

  useEffect(() => {
    if (supportForeignBoardStatus && boardId) {
      getPreviewTaskBoard({ entityId, boardId }, true);
    }
  }, [boardId, entityId, getPreviewTaskBoard, supportForeignBoardStatus]);

  return children({
    status: getStatusById(statusId),
    safeStatus: getStatusByIdWithFallback(statusId),
    isLoading,
  });
};
